import { createRouter, createWebHistory } from 'vue-router';
import MainRoutes from './MainRoutes';
import AuthRoutes from './AuthRoutes';
import { useAuthStore } from '@/stores/auth';
import DidNumbers from '@/views/apps/numbers/DidNumbers.vue'
import DidNumber from '@/views/apps/numbers/DidNumber.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    MainRoutes,
    AuthRoutes,
    {
      path: '/numbers',
      name: 'did-numbers',
      component: DidNumbers,
      meta: {
        requiresAuth: true,
        title: 'DID Numbers'
      }
    },
    {
      path: '/numbers/:id',
      name: 'did-number',
      component: DidNumber,
      meta: {
        requiresAuth: true,
        title: 'DID Number'
      }
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/auth/login'
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAuthenticated = authStore.isAuthenticated;

  if (requiresAuth && !isAuthenticated) {
    next('/auth/login');
  } else if (to.path === '/auth/login' && isAuthenticated) {
    next('/dashboard/default');
  } else {
    next();
  }
});

export default router;
